<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.stock-reorder.update-stock-reorder.error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">
		{{ 'mes.stock-reorder.update-stock-reorder.title' | translate }}
	</h1>

	<mat-dialog-content>
		<div class="reorder-layout pad-top-20">
			<div class="reorder-left">
				<mat-form-field appearance="outline" class="dialog">
					@if (controls['partNumber'].invalid && controls['partNumber'].touched) {
						<mat-error>
							{{ 'mes.stock-reorder.update-stock-reorder.error.part-number' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.stock-reorder.update-stock-reorder.part-number' | translate }}
					</mat-label>
					<input maxlength="255" matInput formControlName="partNumber" />
				</mat-form-field>

				<mat-form-field appearance="outline" class="dialog">
					@if (controls['incidentCodeId'].invalid && controls['incidentCodeId'].touched) {
						<mat-error>
							{{ 'mes.stock-reorder.update-stock-reorder.error.incident-code' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.stock-reorder.update-stock-reorder.incident-code' | translate }}
					</mat-label>
					<mat-select formControlName="incidentCodeId" panelClass="incident-code-panel">
						@for (group of incidentCodesByGroup; track group) {
							<mat-optgroup [label]="group.group">
								@for (incidentCode of group.codes; track incidentCode) {
									<mat-option [value]="incidentCode.id">
										{{ incidentCode.name }}
									</mat-option>
								}
							</mat-optgroup>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field appearance="outline" class="dialog">
					@if (controls['title'].invalid && controls['title'].touched) {
						<mat-error>
							{{ 'mes.stock-reorder.update-stock-reorder.error.type' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.stock-reorder.update-stock-reorder.type' | translate }}
					</mat-label>
					<mat-select formControlName="title">
						@for (reordertype of reordertypes; track reordertype) {
							<mat-option [value]="reordertype">{{ reordertype }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="reorder-right">
				<mat-form-field appearance="outline" class="dialog note-field">
					<mat-label class="mat-body-1">
						{{ 'mes.stock-reorder.update-stock-reorder.note' | translate }}
					</mat-label>
					<textarea matInput formControlName="note" rows="10" maxlength="255"></textarea>
				</mat-form-field>
			</div>
		</div>
		<app-reorder-production-note-list [alias]="data.itemAlias" [employees]="employees"></app-reorder-production-note-list>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">
			{{ 'general.ok' | translate }}
		</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
			{{ 'general.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</form>
